module.exports = __webpack_public_path__ + "img/guide_page_bottom.68ad0b49.png";